import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import { getUserResponse } from '../../shared/answer-helpers';
import { getBookCover } from '../../shared/book-covers';
import '../../assets/images/emoji-sprites/emoji-sprite-v58-20.css';
import styles from './BookComparisonBlock.css';

const ROWS = [
    ['fog', 'Let your best memories go blurry', 'lock', 'Lock them in before they fade'],
    ['wine-glass', 'Tell the story, forget the best line', 'studio-microphone', 'Get every juicy detail down, word for word'],
    ['mobile-phone', 'Own 2,000 photos and zero backstory', 'camera-with-flash', 'Know the story behind every single one'],
    ['shushing-face', 'Keep the wild stuff in your head', 'nail-polish', 'Let people read it (or don’t, your call)'],
    ['hourglass-not-done', 'Say “I’ll write it someday” (again)', 'writing-hand', 'Start tonight: a chapter after two answers'],
    ['pleading-face', 'Be the one with the stories', 'open-book', 'Be the one with the book']
];

function BookComparisonBlock({ userResponses }) {
    const name = getUserResponse(userResponses, 9114)?.text;
    const titleResponse = getUserResponse(userResponses, 9111);

    return (
        <section className={styles.root}>
            <div className={styles.book}>
                <span className={styles.coverWrap}>
                    <img src={getBookCover(userResponses)} alt='' className={styles.cover} />
                </span>
                <span className={styles.bookInfo}>
                    <span className={styles.kicker}>Your digital e-book</span>
                    <span className={styles.bookTitle}>{titleResponse?.text}</span>
                    {Boolean(name) && <span className={styles.author}>by {name}</span>}
                </span>
            </div>
            <h2 className={styles.heading}>Don’t let this book stay a <em>quiz result</em></h2>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th scope='col'>If you skip it <EmojiIcon name='see-no-evil-monkey' version='v58-20' className={styles.headEmoji} /></th>
                        <th scope='col'>If you write it <EmojiIcon name='sparkles' version='v58-20' className={styles.headEmoji} /></th>
                    </tr>
                </thead>
                <tbody>
                    {ROWS.map(([skipIcon, skipText, writeIcon, writeText]) => (
                        <tr key={skipText}>
                            <td>
                                <span className={styles.cell}>
                                    <EmojiIcon name={skipIcon} version='v58-20' />
                                    {skipText}
                                </span>
                            </td>
                            <td>
                                <span className={styles.cell}>
                                    <EmojiIcon name={writeIcon} version='v58-20' />
                                    {writeText}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    );
}

BookComparisonBlock.propTypes = {
    userResponses: PropTypes.array.isRequired
};

export {
    BookComparisonBlock
};
